export default __webpack_public_path__ + "static/media/nfls.e39b137a.png";